export const PIC_DELIMITER = "|";

export type SideLoadedMatchedField = "abn" | "pic" | "brands" | "email";

export const MATCHED_FIELD_LABELS: Record<SideLoadedMatchedField, string> = {
  abn: "ABN",
  pic: "PIC",
  brands: "Brands",
  email: "Email",
};

export type SideLoadedBusinessRow = SideLoadedBusiness & {
  matchedFields?: SideLoadedMatchedField[];
  validationIssues?: string[];
};
